import { useEffect } from 'react';

export default function useScrollReveal() {
  useEffect(() => {
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => {
        if (e.isIntersecting) {
          const activeClass = e.target.classList.contains('sa') ? 'on' : 'visible';
          e.target.classList.add(activeClass);
          obs.unobserve(e.target); // animate once, then stop watching
        }
      }),
      { threshold: 0.12, rootMargin: '0px 0px 0px 0px' }
    );

    const observe = () =>
      document.querySelectorAll('.reveal:not(.visible), .sa:not(.on)').forEach(el => obs.observe(el));

    observe();
    // Pick up any elements injected by Firestore after initial render
    const t = setTimeout(observe, 800);
    return () => { clearTimeout(t); obs.disconnect(); };
  }, []);
}
